import { render, staticRenderFns } from "./ApplyForm.vue?vue&type=template&id=24c273f8&scoped=true&"
import script from "./ApplyForm.vue?vue&type=script&lang=ts&"
export * from "./ApplyForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c273f8",
  null
  
)

export default component.exports